import { create } from 'zustand';
import type { ViewerOem } from '../viewer/oem';

// ============================================================
// 主站 OEM（DW-P1-6）：通过 ?oemToken=<发布令牌> 入口加载品牌（登录页背景/标题/图标）
// 发布链接查看器自身用快照 OEM，不依赖本 store
// ============================================================

interface OemState {
  oem: ViewerOem | null;
  setOem: (oem: ViewerOem | null) => void;
}

export const useOemStore = create<OemState>((set) => ({
  oem: null,
  setOem: (oem) => set({ oem }),
}));
